import { useNavigate } from "@tanstack/react-router"
import { motion } from "motion/react"

import { Loader, ProductlaneIcon } from "@productlane/ui"

import { MetaInfo } from "@/components/meta-info"
import { api } from "@/lib/api"
import { useSetupWorkspace } from "@/lib/states/setup-workspace-state"
import { shouldTriggerLinearSync } from "./should-trigger-linear-sync"

export function SetupLinearScreen() {
	const navigate = useNavigate()

	const syncLinearMutation = api.linear.syncLinear.useMutation({
		onSuccess: () => {
			// Store flag to show toast after curtain animation
			sessionStorage.setItem("linear-sync-started", "true")
		},
		onError: () => {
			// Store error flag to show toast after curtain animation
			sessionStorage.setItem("linear-sync-error", "true")
		},
	})
	const { startSetup, setStep } = useSetupWorkspace()
	api.workspace.info.useQuery(undefined, {
		onSuccess: (data) => {
			try {
				if (!data.linearConnected) {
					void navigate({ to: "/threads" })
				} else if (
					shouldTriggerLinearSync({
						linearConnected: data.linearConnected,
						hasBeenSetup: data.hasBeenSetup,
					})
				) {
					// Trigger sync in background, don't wait for completion
					syncLinearMutation.mutate()
				}
			} catch (error) {
				console.error({
					title: "Sync failed",
					description: "Something went wrong syncing your Linear data.",
				})
			}
			if (data.hasBeenSetup) {
				void navigate({ to: "/threads" })
				// await dropAllDatabases()
				if (typeof window !== "undefined") {
					window.location.reload()
				}
			} else {
				// Workspace was just created by the Linear OAuth flow — resume onboarding
				// at the name step (step 1), which prefills the Linear org name for editing.
				// The query param is load-bearing: SetupWorkspaceScreen's init effect resets
				// step to 0 unless `?step=` is present.
				startSetup()
				setStep(1)
				void navigate({ href: `/setup-workspace?step=1` })
			}
		},
	})
	return (
		<main className="relative flex h-dvh w-full flex-col items-center p-6">
			<MetaInfo title="Setup Linear" />

			<div className="flex flex-1 items-center justify-center">
				<motion.div
					initial={{ opacity: 0, y: 10 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{
						opacity: { duration: 0.1 },
						y: { type: "tween", duration: 0.3 },
					}}
					className="z-40 flex w-screen max-w-[80vw] flex-col items-center gap-4 rounded-3xl bg-white p-14 shadow-lg ring-1 ring-black/10 sm:max-w-lg dark:bg-gray-800 dark:shadow-xl dark:shadow-black dark:ring-white/10"
				>
					<div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-[#191A1C] ring-1 ring-white/10">
						<ProductlaneIcon fill="white" className="h-10" />
					</div>
					<div className="flex flex-col items-center">
						<div className="mt-0 text-3xl font-bold">Productlane</div>
						<p className="mt-2 text-center text-secondary">
							Syncing Linear projects, issues and customers
						</p>
					</div>
					<Loader className="text-green-500" />
				</motion.div>
			</div>
		</main>
	)
}
